import { toastMachine } from "@filadd/phi-plus-core";
import { DateTime } from "luxon";
import { useEffect, useRef } from "react";
export const ToastNotification = ({ id, title, body, toast_type: toastType = "info", created_at: createdAt, onOpen, onClose, onIgnore, }) => {
    const displayedRef = useRef(false);
    useEffect(() => {
        // make sure the notification is not displayed more than once
        if (displayedRef.current) {
            return;
        }
        displayedRef.current = true;
        const minutesSinceCreated = -DateTime.fromISO(createdAt, { zone: "utc" })
            .diffNow("minutes")
            .as("minutes");
        if (minutesSinceCreated > 1) {
            // we don't want to spam old toasts, ignore them
            onIgnore();
            return;
        }
        toastMachine.create({
            id,
            type: toastType,
            title: title !== null && title !== void 0 ? title : body,
            description: title != null ? body : undefined,
            duration: 5000,
            onStatusChange: ({ status }) => {
                switch (status) {
                    case "visible":
                        onOpen();
                        break;
                    case "dismissing":
                        onClose();
                        break;
                    default:
                }
            },
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return null;
};
//# sourceMappingURL=ToastNotification.js.map